export default {
  "zh-CN": {
    title: "中文",
    serverError: {
      "000100": "用户会话超时!",
      "000200": "安全服务错误!",
      "000300": "校验服务错误!",
      "000400": "系统后台错误!",
      "000500": "网络服务错误!"
    },
    httpError: {
      title: "请求服务器失败",
      "404": "服务器无法找到资源!",
      "406": "请求格式无效!",
      "400": "服务器拒绝了您的请求!",
      "500": "服务器有一个错误!",
      "504": "服务器请求超时!"
    },
    ui: {
      sysCode: {
        noCode: "数据错误"
      }
    },
    common: {
      serverReceiving: "服务器受理中...",
      tableLoading: "数据加载中..."
    }
  },
  en: {
    title: "English",
    httpError: {
      title: "request server failed",
      "404": "server cannot find resource ",
      "406": "the request format is invalid.",
      "400": "the server has rejected your request ! ",
      "500": "the server has an error !",
      "504": "the server request time out !"
    },
    ui: {
      sysCode: {
        noCode: "data error"
      }
    },
    common: {
      serverReceiving: "server processing...",
      tableLoading: "data loading..."
    }
  }
};
